import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { RouterModule } from "@angular/router";
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DataTableModule } from "angular2-datatable";
import { ListadosComponent } from "./listados.component";
import { ListadosServices } from "./listados.service";
import { DataFilterPipe1, DataFilterPipe2, DataFilterPipe3 } from "./listados.filter";



@NgModule({
    declarations: [ListadosComponent, DataFilterPipe1, DataFilterPipe2,DataFilterPipe3],
    imports: [BrowserModule, HttpModule, FormsModule, BrowserAnimationsModule, RouterModule, DataTableModule],
    exports: [ListadosComponent],
    providers: [ListadosServices]
})

export class ListadosModule { }



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/vamEmpresa/listados/listados.module.ts